import { render, staticRenderFns } from "./PrivateShow.vue?vue&type=template&id=748acca8&scoped=true"
import script from "./PrivateShow.vue?vue&type=script&lang=js"
export * from "./PrivateShow.vue?vue&type=script&lang=js"
import style0 from "./PrivateShow.vue?vue&type=style&index=0&id=748acca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748acca8",
  null
  
)

export default component.exports